import React, { useEffect, useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import "./ThemeToggle.css";

const Sun = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="5" fill="currentColor" />
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="12" y1="1.5" x2="12" y2="3.5" />
      <line x1="12" y1="20.5" x2="12" y2="22.5" />
      <line x1="4.2" y1="4.2" x2="5.7" y2="5.7" />
      <line x1="18.3" y1="18.3" x2="19.8" y2="19.8" />
      <line x1="1.5" y1="12" x2="3.5" y2="12" />
      <line x1="20.5" y1="12" x2="22.5" y2="12" />
      <line x1="4.2" y1="19.8" x2="5.7" y2="18.3" />
      <line x1="18.3" y1="5.7" x2="19.8" y2="4.2" />
    </g>
  </svg>
);

const Moon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M21 12.79A9 9 0 0111.21 3a7 7 0 1010.79 9.79z"
    />
  </svg>
);

export default function ThemeToggle() {
  const { theme, setMode } = useTheme();
  const isDark = theme === "dark";
  const nextMode = isDark ? "light" : "dark";

  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        const y = window.scrollY;
        const delta = y - lastY;

        // Siempre visible cerca del top
        if (y < 80) {
          setHidden(false);
        } else if (delta > 10) {
          // bajando
          setHidden(true);
        } else if (delta < -10) {
          // subiendo
          setHidden(false);
        }

        lastY = y;
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      className={`themeFab ${hidden ? "is-hidden" : ""}`}
      onClick={() => setMode(nextMode)}
      aria-label={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      title={isDark ? "Modo claro" : "Modo oscuro"}
    >
      <span className="themeFab__icon">
        {isDark ? <Sun /> : <Moon />}
      </span>
    </button>
  );
}